import { DocumentStatusEnum, DocumentTypeEnum } from '../enums';

import { ENROLL_METHOD, IndividualAddressTypeEnum } from './enroll';


/* eslint-disable no-multiple-empty-lines */

export enum ENROLL_AUTH_REQUEST_TYPE {
  REGISTER,
  CONFIRM_EMAIL,
  RESEND_EMAIL,
  SEND_PHONE_CODE,
  VERIFY_PHONE_CODE,
  RECOVER,
  GET_CLIENTS,
  SET_CLIENTS,
  REDEEM_SIGNUP_TOKEN,
}

export type EnrollAuthRequestBody = {
  requestType: ENROLL_AUTH_REQUEST_TYPE
}

// TODO: Rename to EnrollCRMRequestBodyAbstract
export type EnrollRequestBodyAbstract = {
  callMethod: ENROLL_METHOD
  callMethodName: string
  callNo?: number
}

// TODO: Rename to EnrollCRMGetRequestBody
export type EnrollGetRequestBody = {
  params?: string[]
} & EnrollRequestBodyAbstract

// TODO: Rename to EnrollCRMPostRequestBody
export type EnrollPostRequestBody = {
  requestBody: any
} & EnrollRequestBodyAbstract

export type EnrollPutRequestBody = EnrollGetRequestBody

export type EnrollDeleteRequestBody = {
  id: any
} & EnrollRequestBodyAbstract

export type EnrollCall = (
  EnrollGetRequestBody | EnrollPostRequestBody | EnrollPutRequestBody | EnrollDeleteRequestBody
) & {
  isQueued?: boolean
}

// Step 3



// Step 4



export enum GenderTypeEnum {
  unspecified = 'U',
  male = 'M',
  female = 'F'
}

// Step 6



// Step 7



// Step 8
export type EnrollIndividualIdentityDetailRequestData = {
  id?: number | null
  identity_document_type: IdentityDocumentSubTypesEnum // 'PAS
  identity_number: string
  review_status?: string
  expiration_date?: string // '2021-01-14T00:33:25.333Z',
  review_summary?: string
  proof_of_identity_id?: number | null
}



// Step 9



// Step 10
export type EnrollIndividualTaxDetailData = {
  id?: number | null
  country_id: string
  tax_number: string
  proof_of_tax_detail_id?: number
  review_status?: string
  review_summary?: string
  trace_identifier?: string
}

export type EnrollIndividualTaxDetailRequestData = EnrollIndividualTaxDetailData[]


// Step 11



// Step 12
export type EnrollIndividualAddressRequestData = {
  id?: number | null
  address_type: IndividualAddressTypeEnum
  country_id: string
  city: string
  state_province_county?: string
  zip_code: string
  address_line: string
  proof_of_address_id?: number
  review_status?: string
  review_summary?: string
  trace_identifier?: string
}


// Step 13



// Step 14



// Step 15



// Step 16



// Step 17



// Step 18



// Step 19



// Step 20



// Step 22



// Step 26



// Step 27.2: POST/PUT - upload files
export type EnrollIndividualDocumentOwnRequestData = {
  id?: number,
  document_type: string // DocumentTypesEnum
  sub_document_type: string
  file_name: string
  status?: DocumentStatusEnum
  file_storage_id: string[]
  upload_stamp?: string // "2021-01-29T14:44:25.628Z"
  uploaded_by: number // user id
  modify_stamp?: string // "2021-01-29T14:44:25.628Z"
  modified_by?: number
  review_summary?: string
  is_hidden_for_client: boolean | null // true
  poi_document_id?: number
  trace_identifier?: string
}

export enum AddressDocumentSubTypesEnum {
  bankStatement = 'BNK',
  utilityBill = 'BIL'
}

export enum IdentityDocumentSubTypesEnum {
  unspecified = 'UNS',
  passport = 'PAS',
  identityCard = 'IDC',
  drivingLicense = 'DRV'
}

/**
 * Used for denoting what is uploaded by the user interface
 * After a file is uploaded it is registered with this info
 */
export type FileUploadRegisterData = {
  type: DocumentTypeEnum
  subType: string
  fileName: string
}

export const AppDocumentUploadCategories: ({[key: string]: FileUploadRegisterData}) = {
  PASSPORT: {
    type: DocumentTypeEnum.ProofOfIdentity,
    subType: IdentityDocumentSubTypesEnum.passport,
    fileName: 'passport.jpg',
  },
  ID_FRONT: {
    type: DocumentTypeEnum.ProofOfIdentity,
    subType: IdentityDocumentSubTypesEnum.identityCard,
    fileName: 'id-front.jpg',
  },
  ID_BACK: {
    type: DocumentTypeEnum.ProofOfIdentity,
    subType: IdentityDocumentSubTypesEnum.identityCard,
    fileName: 'id-back.jpg',
  },
  ADDRESS_PROOF_UTILITY_BILL: {
    type: DocumentTypeEnum.ProofOfAddress,
    subType: AddressDocumentSubTypesEnum.utilityBill,
    fileName: 'proof-of-address.jpg',
  },
  ADDRESS_PROOF_BANK_STATEMENT: {
    type: DocumentTypeEnum.ProofOfAddress,
    subType: AddressDocumentSubTypesEnum.bankStatement,
    fileName: 'proof-of-address.jpg',
  },
  SELFIE: {
    type: DocumentTypeEnum.Selfie,
    subType: '',
    fileName: 'selfie',
  },
};

// Step 28



// Step 32

// Step 33


export const REQUEST_CALL_NAME_CONFIRM_EMAIL = 'enrollAuth/CONFIRM_EMAIL';
export const REQUEST_CALL_NAME_REDEEM_SIGNUP_TOKEN = 'enrollAuth/REDEEM_SIGNUP_TOKEN';
